/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import config from 'js/app/config';

import { track } from '@coursera/event-pulse/sdk';

import MobileButton from 'bundles/composable-page-header/components/mobile-menu-items/MobileButton';
import { addUtmInfo } from 'bundles/ent-website/components/MetaNavigation';

import _t from 'i18n!nls/composable-page-header';

const styles = {
  separator: css`
    border-top: 1px solid var(--cds-color-neutral-stroke-primary-weak);
    list-style-type: none;
    margin-top: var(--cds-spacing-100);
    padding: 0 0 var(--cds-spacing-100);
    margin-bottom: var(--cds-spacing-100);
  `,
};

const metaNavButtons = [
  {
    href: addUtmInfo(`${config.url.base}business`, '/business'),
    label: _t('For Businesses'),
    name: 'businesses',
    onButtonClick: () => {
      track('click_meta_nav', {
        metaNavValue: 'for_businesses',
      });
    },
  },
  {
    href: addUtmInfo(`${config.url.base}campus`, '/campus'),
    label: _t('For Universities'),
    name: 'universities',
    onButtonClick: () => {
      track('click_meta_nav', {
        metaNavValue: 'for_universities',
      });
    },
  },
  {
    href: addUtmInfo(`${config.url.base}government`, '/government'),
    label: _t('For Governments'),
    name: 'government',
    onButtonClick: () => {
      track('click_meta_nav', {
        metaNavValue: 'for_governments',
      });
    },
  },
];

const MetaNavMenuItem = () => {
  return (
    <React.Fragment>
      <li css={styles.separator} />
      {metaNavButtons.map((button) => {
        return <MobileButton key={button.name} {...button} />;
      })}
    </React.Fragment>
  );
};

export default MetaNavMenuItem;
